module.exports = __webpack_public_path__ + "static/media/salesforceb.39451198.png";